




























































































/* General */
import Vue from 'vue'
import ProjectSettingsLayout from '@/layouts/project-settings-layout.vue'
import * as routerNames from '@/services/router/router.names'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { EEntities } from '@/types'
import { IItemForSelection } from '@/api/types/response.types'

/* API */
import InternalProjectsAPI from '@/api/modules/internal-projects.api'
import { IInternalProjectsInputGeneralSettings } from '@/api/types/request.types'

export default Vue.extend({
  name: 'ProjectSettingsGeneralSettings',

  metaInfo(): any {
    return {
      title: `General Settings - ${this.savedName}`,
    }
  },

  components: {
    ProjectSettingsLayout,
    EntitySettingsLoading,
  },

  data() {
    return {
      EEntities,
      ColorAssistant,

      isLoading: true,
      isUpdating: false,
      isArchiving: false,
      isDeleting: false,

      tagIDsToDelete: [] as number[],

      savedName: '',
      name: '',
      tags: [] as IItemForSelection[],
    }
  },

  computed: {
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
    isSubmitting(): boolean {
      return this.isUpdating || this.isArchiving || this.isDeleting
    },
  },

  async created() {
    this.isLoading = true
    await this.getGeneralSettingsInfo()
    this.isLoading = false
  },

  methods: {
    addToTagIDsToDelete(id: number) {
      this.tags = this.tags.filter(t => t.id !== id)
      if (!this.tagIDsToDelete.includes(id)) {
        this.tagIDsToDelete.push(id)
      }
    },
    async getGeneralSettingsInfo() {
      try {
        const response = await InternalProjectsAPI.get_GeneralSettings(this.id)
        this.name = response.name
        this.savedName = this.name
        this.tags = response.listTags
      } catch (error) {
        this.$error.emit(error)
      }
    },
    async updateInternalProject() {
      try {
        this.isUpdating = true
        const data = {
          name: this.name,
          listTagIDsToDelete: this.tagIDsToDelete,
        } as IInternalProjectsInputGeneralSettings
        const response = await InternalProjectsAPI.post_GeneralSettings(
          this.id,
          data,
        )
        this.savedName = this.name
        this.$messaging.showSuccess(response.message)
      } catch (error) {
        this.$error.emit(error)
        this.name = this.savedName
      } finally {
        this.isUpdating = false
      }
    },
    async handleArchive(): Promise<void> {
      try {
        await this.$confirm(
          `<strong>Tasks can no longer be created while this is archived.</strong>
          <br>Are you sure you want to archive this project?`,
          {
            dangerouslyUseHTMLString: true,
            center: true,
            confirmButtonText: 'Yes, Archive',
            confirmButtonClass: 'el-button--primary',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'el-button--text',
            type: 'warning',
            title: `Archive this Project`,
          },
        )
        this.isArchiving = true
        await InternalProjectsAPI.post_Archive(this.id)
        this.$router.push({ name: routerNames.DASHBOARD })
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        this.isArchiving = false
      }
    },
    async handleDelete(): Promise<void> {
      try {
        await this.$confirm(
          `<strong>This action is permanent.</strong>
          <br>Are you sure you want to delete this project?`,
          {
            dangerouslyUseHTMLString: true,
            center: true,
            confirmButtonText: 'Yes, Delete',
            confirmButtonClass: 'el-button--strawberry',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'el-button--text',
            type: 'warning',
            title: `Delete this Project`,
          },
        )
        this.isDeleting = true
        await InternalProjectsAPI.post_Delete(this.id)
        this.$router.push({ name: routerNames.DASHBOARD })
        this.isDeleting = false
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        this.isDeleting = false
      }
    },
  },
})
